import { render, staticRenderFns } from "./pay-info.vue?vue&type=template&id=6945f3dc"
import script from "./pay-info.vue?vue&type=script&lang=js"
export * from "./pay-info.vue?vue&type=script&lang=js"
import style0 from "./pay-info.vue?vue&type=style&index=0&id=6945f3dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports